module.exports = __webpack_public_path__ + "img/presentation_POE.c9866ca1.png";